import { makeStyles } from "@mui/styles"

export const useSelectionHintStyles = makeStyles({
  notification: {
    "& > [class*='title']": {
      fontWeight: "normal !important",
    },
    "& > button": {
      fontSize: "14px",
      fontWeight: "bold",
    },
    "& > div": {
      border: "none !important",
      fontSize: "12px",
      justifyContent: "center !important",
      maxWidth: "unset !important",
      width: "auto",
    },
    "& > span": {
      fontSize: "14px",
      verticalAlign: "middle",
    },
    "&:hover": {
      backgroundColor: "#f9f9f9 !important",
    },

    backgroundColor: "#f9f9f9",
    display: "block !important",
    height: "53px",
    lineHeight: "53px",
    margin: "5px 0",
    textAlign: "center",
    width: "auto !important",
  },
})
